import React from 'react';
import './ThinkingIndicator.css';

const ThinkingIndicator = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="thinking-dots thinking-dots-inline" aria-label="Edge AI is thinking">
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </div>
    );
  }

  return (
    <div className="thinking-indicator-bubble">
      <div className="thinking-indicator-content">
        <img
          src="/edge-ai-thinking-logo.png"
          alt="Edge AI"
          className="thinking-indicator-badge"
        />
        <div className="thinking-dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </div>
      </div>
      <span className="thinking-indicator-text">Edge AI is thinking...</span>
    </div>
  );
};

export default ThinkingIndicator;
